import { createSdk } from "@hyper-fetch/core";
import { createSocketSdk } from "@hyper-fetch/sockets";

import { client, socket } from "./client";
import { userConfiguration } from "./user/user.configuration";
import { organizationsConfiguration } from "./organizations/organizations.configuration";
import { notificationsConfiguration } from "./notifications/notifications.configuration";
import type { ApiRoutesSdk, WsSocketSdk } from "@inginuiti/backend";

export const sdk = createSdk<typeof client, ApiRoutesSdk>(client)
  .$configure(userConfiguration)
  .$configure(organizationsConfiguration)
  .$configure(notificationsConfiguration);

export const socketSdk = createSocketSdk<typeof socket, WsSocketSdk>(socket);
